module.exports = __webpack_public_path__ + "img/chess-bishop-piece.1be5e219.svg";